import {postRequest} from "../../src/api/index.js";
import {
    AUTH_ERROR,
    AUTH_ROLE,
    AUTH_USER,
    CURRENT_USER,
    REGISTER,
    REGISTER_ERROR,
    UPDATE_LOGO
} from "../../src/actions/types.js";

export const register = async (data, cb) => async (
    dispatch
) => {
    try {
        const {firstName, lastName, ...objToSend} = data;
        let res = null;
        if (!data.encString || data.encString.length === 0) {
            res = await postRequest(`/user/register`, "user", objToSend, (status) => {
                return (status >= 200 && status < 300) || status === 400 || status === 500; // default
            });
        } else {
            res = await postRequest(`/user/inviteUserQrCode/${data.encString}`, "user", data, (status) => {
                return (status >= 200 && status < 300) || status === 400 || status === 500; // default
            });
        }

        if (res.status === 500 || res.status === 400) {
            dispatch({
                type: AUTH_ERROR,
                payload: 'We are sorry. The username or password you used is incorrect.'
            });
        } else if (res.status !== 400) {
            dispatch({
                type: 'RESET'
            });
            sessionStorage.clear();
            localStorage.clear();

            if (!data.encString || data.encString.length === 0) {
                dispatch({type: AUTH_USER, payload: res.data});
                dispatch({type: CURRENT_USER, payload: res.data.user});

                // Store in both sessionStorage (tab-isolated) and localStorage (persistence)
                sessionStorage.setItem("user", JSON.stringify(res.data.user));
                sessionStorage.setItem("token", res.data.jwt);
                sessionStorage.setItem("expiresIn", new Date(res.data.expiresIn).getTime());
                localStorage.setItem("user", JSON.stringify(res.data.user));
                localStorage.setItem("token", res.data.jwt);
                localStorage.setItem("expiresIn", new Date(res.data.expiresIn).getTime());
            }
            cb();
        }
    } catch (err) {
        if (err.response) {
            // There is an error response from the server
            // You can anticipate error.response.data here
            if (err.response.data && err.response.data.errors[0]) {
                dispatch({
                    type: REGISTER_ERROR,
                    payload: err.response.data.errors[0]
                });
            } else {
                const error = err.response.data;
                dispatch({
                    type: REGISTER_ERROR,
                    payload: err.message
                });
            }
        } else if (err.request) {
            // The request was made but no response was received
            // Error details are stored in error.reqeust
            dispatch({
                type: REGISTER_ERROR,
                payload: err.request
            });
        } else if (err) {
            dispatch({
                type: REGISTER_ERROR,
                payload: err.message
            });
        } else {
            // Some other errors
            dispatch({
                type: REGISTER_ERROR,
                payload: "Something went wrong."
            });
        }
    }
};
